define.alias("shared/components/shared/social-identity", "calendar/components/shared/social-identity");